import * as React from 'react';

export class Program extends React.Component<any, any> {
    render() {
        return (
            <section className="program">
                <h1>Программа мероприятия</h1>
    
                <div>
                    <aside>
                        <h2>Суббота</h2>
                        <div className="schedule">
                            <b>10:00</b>
                            <span>Торжественное открытие Мероприятия</span>
    
                            <b>11:00 &mdash; 11:30</b>
                            <span>История AKG</span>

                            <b>12:00 &mdash; 12:30</b>
                            <span>Российская премьера! Презентация серии F &mdash; ультракомпактных японских наушников Final. </span>

                            <b>13:00 &mdash; 13:30</b>
                            <span>Презентация нового британского бренда &mdash; RHA</span>

                            <b>14:00 &mdash; 15:00</b>
                            <span>Официальная презентация новых продуктов SONY в России</span>

                            <b>16:00 &mdash; 16:30</b>
                            <span>Семинар: Наушники Электростатические Stax новой серии Лямбда</span>
                             
                            <b>17:00 &mdash; 17:30</b>
                            <span>BOSE &mdash; система активного шумоподавления. 40 лет развития технологии.</span>

                            <b>18:00 &mdash; 18:30</b>
                            <span>Вручение наград "продукт года" по версии LOUDHEAD</span>
                        </div>
                    </aside>
                    <aside>
                        <h2>Воскресенье</h2>
                        <div className="schedule">
                            <b>10:00</b>
                            <span>Открытие второго дня</span>
                            
                            <b>11:00 &mdash; 11:30</b>
                            <span>История AKG</span>
    
                            <b>12:00 &mdash; 12:30</b>
                            <span>Российская премьера! Презентация серии F &mdash; ультракомпактных японских наушников Final.</span>
    
                            <b>13:00 &mdash; 13:30</b>
                            <span>Презентация нового британского бренда &mdash; RHA</span>
    
                            {/*<b>15:00 &mdash; 15:30</b>
                            <span>Презентация наушников AKG N90Q</span>*/}
    
                            <b>16:00 &mdash; 16:30</b>
                            <span>BOSE &mdash; система активного шумоподавления. 40 лет развития технологии.</span>
    
                            <b>17:00 &mdash; 17:30</b>
                            <span>Вручение наград лучшим системам форума DrHead</span>
    
                            <b>18:00 &mdash; 18:30</b>
                            <span>Окончание выставки</span>
                        </div>
                    </aside>
                </div>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Visitors/Program.tsx
 **/